((holiday2021ProductsCarousel, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.homeProductsCarouselRedesign = $('.js-home-products-carousel-redesign--products-list-slider');
  };

  const bindUIActions = () => {
    $dom.homeProductsCarouselRedesign.slick({
      infinite: false,
      dots: true,
      arrows: true,
      slidesToShow: 4.9,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 801,
          settings: {
            slidesToShow: 2.3,
            slidesToScroll: 2,
            arrows: false,
          },
        },
      ],
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  holiday2021ProductsCarousel.init = init;
})((window.holiday2021ProductsCarousel = window.holiday2021ProductsCarousel || {}), jQuery);
